exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-table thead th {\n  border-top: 0;\n  text-transform: uppercase;\n  padding: .65rem;\n  font-size: 12px;\n  text-align: right; }\n\n.grid-table th {\n  font-size: 12px; }\n\n.grid-table td {\n  padding: .65rem;\n  font-size: 12px; }\n\ntr.total {\n  background-color: rgba(0, 0, 0, 0.01); }\n\n.lowFontWeight {\n  font-weight: 400;\n  padding-left: 20px;\n  font-size: 13px; }\n\n.alert-success {\n  background-color: #d4edda !important;\n  border-color: #fff !important;\n  color: #2ecc71 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/profit-loss/profit-loss.component.scss
// module id = ../../../../../src/app/finance-management/profit-loss/profit-loss.component.scss
// module chunks = main